'use strict';

const { parseTopBids, parseProductBidData } = require('./adformResponseParserHelpers');
const adformConstants = require('../adformConstants');
const adformEventDispatcher = require('../adformEventDispatcher');

/**
 * Returns array of parsed bid objects that can be used to generate html (img ad with link).
 * @param {Array} topBids - array of bids from response (sorted by price)
 * @return {Object[]} - array of parsed bid objects
 */
function getValidBids(topBids) {
    let validBids = [];
    for (let i = 0; i < topBids.length; i++) {
        const bid = topBids[i];
        const parsedBid = parseProductBidData(bid);
        if (!parsedBid) {
            // eslint-disable-next-line no-continue
            continue;
        }

        validBids.push(parsedBid);
    }

    return validBids;
}

/**
 * Handles when adform doesn't return bids (informs other modules e.g. products to remove loader)
 */
function handleNoBids() {
    const eventData = {};
    adformEventDispatcher.dispatch(adformConstants.PRODUCT_NO_BIDS_CUSTOM_EVENT_NAME, eventData);
}

/**
 * Handles adform returned bids (informs other modules e.g. product tiles to prepend ads and to remove loader)
 * @param {Object[]} bids - array of parsed bid objects (img, links...)
 */
function handleHasBids(bids) {
    const eventData = {
        detail: {
            bids: bids
        }
    };
    adformEventDispatcher.dispatch(adformConstants.PRODUCT_BIDS_READY_CUSTOM_EVENT_NAME, eventData);
}

/**
 * Handles when adform request if not valid
 */
function handleInvalidRequest() {
    handleNoBids();
}

/**
 * Handles when adform request if not valid
 * @param {Object} error - error from try and catch
 */
function handleError(error) {
    // todo: handle error
    // eslint-disable-next-line no-unused-vars
    let e = error;
    handleNoBids();
}

/**
 * Handles adform 200 code response that has bids data.
 * Converts bids from response into parsed objects that can be used for inserting ads (img, link...) and sends them with dispatchEvent.
 * If not valid bids, informs other modules (e.g. slider to remove placeholder loader...)
 *
 * @param {Object} data - adform response
 */
function handleBidsResponse(data) {
    try {
        const topBids = parseTopBids(data, adformConstants.CATEGORIES_SPONSORED_PRODUCT_ADS_NUM_OF_BIDS);
        if (!topBids.length) {
            handleNoBids();
            return;
        }

        let validBids = getValidBids(topBids);
        if (!validBids.length) {
            handleNoBids();
            return;
        }
        handleHasBids(validBids);
    } catch (e) {
        handleError(e);
    }
}

module.exports = {
    handleInvalidRequest: handleInvalidRequest,
    handleNoBids: handleNoBids,
    handleError: handleError,
    handleBidsResponse: handleBidsResponse
};
